import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React, { createContext, useContext, useState } from "react";
import { useTranslation } from "react-i18next";

type OpenDialog = (title: string, content: string, confirmCb: () => void, closeCallback?: () => void) => void;
const DialogContext = createContext<{ openDialog: OpenDialog }>(null);

export const DialogProvider = ({ children }) => {
	const [open, setOpen] = useState(false);
	const [title, setTitle] = useState("");
	const [content, setContent] = useState("");
	const [closeCallback, setCloseCallback] = useState<() => void | null>();
	const [confirmCallback, setConfirmCallback] = useState<() => void>();

	const openDialog = (title: string, content: string, confirmCb: () => void, closeCallback?: () => void) => {
		setTitle(title);
		setContent(content);
		setConfirmCallback(() => confirmCb);
		setCloseCallback(() => closeCallback);
		setOpen(true);
	};

	const closeDialog = () => {
		setOpen(false);
		closeCallback && closeCallback();
	};

	return (
		<DialogContext.Provider value={{ openDialog }}>
			{children}
			<ConfirmDialog
				open={open}
				onClose={closeDialog}
				onConfirm={confirmCallback}
				title={title}
				content={content}
			/>
		</DialogContext.Provider>
	);
};

export const useConfirmDialog = () => {
	return useContext(DialogContext);
};

export const ConfirmDialog = ({ open, onClose, onConfirm, title, content }) => {
	const { t } = useTranslation(["common"]);

	return (
		<Dialog
			fullWidth
			maxWidth={"sm"}
			open={open}
			onClose={onClose}>
			<DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
			<DialogContent>
				<DialogContentText id="confirm-dialog-description">{content}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					color="inherit"
					onClick={onClose}>
					{t("cancel")}
				</Button>
				<Button
					variant="contained"
					color="primary"
					onClick={() => {
						onConfirm(); /* Add confirm action here */
						onClose();
					}}
					autoFocus>
					{t("confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
